export const FAQS = [
  {
    topic: 'Subscription',
    questions: {
      0: {
        ques: 'What happens when the trial for a subscription expires?',
        ans: [
          'If the subscription trial period expires, there can be 2 possibilities:',
          'First, if a payment option is associated with the subscription and the activation date is on the next day after the trial end date, then subscriptions will be charged to your added payment method and the subscription will move from Trial to Live state.',
          'Second, if a payment option is not associated with the subscription and the activation date is the next day after the trial end date, then subscriptions will be marked as canceled, as the payment could not be done.',
        ],
      },
      1: {
        ques: 'Where can I see my subscription details?',
        ans: [
          'From your Shopify admin account, click ‘Settings’ > ‘Billing’. The list includes your Shopify plan and app subscriptions.',
        ],
      },
    },
  },
  {
    topic: 'Private Whatsapp Account',
    questions: {
      0: {
        ques: 'What is a Private Whatsapp Business Account?',
        ans: [
          'The Private Whatsapp Business Account is a solution for medium to large businesses that enables them to manage high volumes of conversations on WhatsApp to strengthen purchase consideration and deepen customer relationships.',
        ],
      },
      1: {
        ques: 'Is there any charge for creating a WhatsApp Business Account?',
        ans: [
          'There are NO charges for creating a WhatsApp Business Account on SuperLemon.',
        ],
      },
      2: {
        ques: 'What are the benefits of Private Whatsapp Business Account?',
        ans: [
          'It helps you create a unique business identity that injects branding elements into your WhatsApp conversations. You can add your business name, logo, contact numbers, website URLs, store locations, promotional details, and more for a personalized and enhanced business connection with your customers. With this, you also get a verified green tick badge along with your name on WhatsApp.',
        ],
      },
      3: {
        ques: 'Can I create marketing campaigns?',
        ans: [
          'Yes! With SuperLemon, you can easily create and publish marketing campaigns from your WhatsApp Business Account without any limits and also check on how many people ordered from your store after the campaign.',
        ],
      },
    },
  },
  {
    topic: 'Messages',
    questions: {
      0: {
        ques: 'What type of messages can I send on WhatsApp?',
        ans: [
          'You can send both transactional and promotional messages on WhatsApp. A text message can be max 4096 characters long and can contain images, documents, video, and audio.',
        ],
      },
      1: {
        ques: 'Is there any limit on the number of messages I can send?',
        ans: [
          'Your messaging limits are automatically defined by WhatsApp based on the volume and quality of the messages you send. If you send high or medium-quality messages at higher volumes, you will be able to send an unlimited number of messages. Read more about messaging limits here.',
        ],
      },
      2: {
        ques: 'How are messaging charges calculated?',
        ans: [
          'Messaging charges are calculated based on usage i.e on the total number of messages being successfully sent. It is a sum of WhatsApp charges and SuperLemon charges (starting from $0.02 for FREE plan and $0.004 for Growth plan).',
        ],
      },
    },
  },
  {
    topic: 'Others',
    questions: {
      0: {
        ques: 'I have a custom requirement',
        ans: [
          'We create AI-powered chatbots and integrate with 500+ platforms to engage customers in 2-way conversations across marketing, commerce and support workflows.',
        ],
      },
      1: {
        ques: 'My question is not listed here',
        ans: [
          'For any product-related queries and support, email us at: support@superlemon.xyz',
        ],
      },
    },
  },
];
